import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.sass']
})
export class SummaryComponent implements OnInit {
  @Input() color: string;
  @Input() content: string;
  
  constructor() { }

  ngOnInit() {
  }

}
